import {Component, Input, OnInit} from '@angular/core';
import {Curriculum} from '@models/curriculum';
import {ProgramScheduleComponent} from '@pages/layout/program/program-page/program-schedule/program-schedule.component';
import {Program} from '@models/program';
import * as moment from '@node_modules/moment';
import {ProgramService} from '@services/program/program.service';
import {Attendance} from '@models/attendance';
import {Lesson} from '@models/lesson';
import {MatDialog} from '@node_modules/@angular/material';
import {ViewCurriculumComponent} from '@pages/layout/program/program-page/program-curriculum/view-curriculum/view-curriculum.component';

@Component({
  selector: 'app-attendance-overview',
  templateUrl: './attendance-overview.component.html',
  styleUrls: ['./attendance-overview.component.scss']
})
export class AttendanceOverviewComponent implements OnInit {
  curriculumId: number;
  programId: number;
  curriculumName: string;
  programName: string;
  lessons: Lesson[];
  yearAttendance: Attendance[];
  programs: Program[];
  reorganisedSchedule;
  viewCirriculumDialog;

  constructor(
    private programService: ProgramService,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    // console.log(this.yearAttendance);
    console.log(this.lessons);
    if (this.yearAttendance && this.lessons) {
      this.lessons.map( item => {
        // item.count = this.yearAttendance[this.curriculumId][item.id];
        item.count = this.yearAttendance[this.programId][item.id];
      });
    }
    this.programService.getUsersPrograms().subscribe(
      (resp: {data: Program[]}) => {
        this.programs = resp.data;
        if (!this.curriculumName) {
          this.curriculumName = this.resolveCurriculumNameFromPrograms();
        }
        const curr = new Curriculum();
        curr.lessons = this.lessons;
        this.programs.map( pr => pr.curriculum = [curr]);
        const next30Days = moment().add(30, 'days');
        let currentMoment = moment().add(1, 'days');
        while (currentMoment.isBefore(next30Days)) {
         if (this.checkLesson(currentMoment)) {
           currentMoment = next30Days;
         } else {
           currentMoment.add(1, 'days');
         }
        }
      });
  }
  mouseover(event) {
    event.target.parentElement.parentElement.classList.add('hover');
  }
  mouseleave(event) {
    event.target.parentElement.parentElement.classList.remove('hover');
  }
  onOpenViewCurriculumModal(lesson) {
    console.log(lesson);
    ViewCurriculumComponent.source = 'student';
    ViewCurriculumComponent.onlyLesson = true;
    ViewCurriculumComponent.program = this.programs[this.programId];
    ViewCurriculumComponent.initLesson = lesson;
    ViewCurriculumComponent.fullContent = false;
    ViewCurriculumComponent.onlyDescription = true;
    this.viewCirriculumDialog = this.dialog.open(ViewCurriculumComponent, {
      panelClass: 'mkc-dashboard-lesson-dialog',
      backdropClass: 'mkc-dashboard-lesson-backdrop'
    });
    ViewCurriculumComponent.modalRef = this.viewCirriculumDialog;
    this.viewCirriculumDialog.afterClosed().subscribe(result => {
      this.viewCirriculumDialog.close();
    });
  }
  checkLesson(day) {
    let finished = false;
    // console.log(day.format('ll'));
    this.reorganisedSchedule = ProgramScheduleComponent.getClassByDate(this.programs[0], this.programs, day, {}, false);
    // console.log(this.reorganisedSchedule, this.programs);
    Object.keys(this.reorganisedSchedule).map( date => {
      Object.keys(this.reorganisedSchedule[date]).map( dayNumber => {
        Object.keys(this.reorganisedSchedule[date][dayNumber]).map( classId => {
          this.reorganisedSchedule[date][dayNumber][classId].map( classL => {
            let classesWithNextDate = 0;
            // console.log(classL);
            if (classL && classL.lesson) {
              this.lessons.map( lessC => {
                if (lessC.id === classL.lesson.id && !lessC.nextTime) {
                  // console.log(classL);
                  lessC.nextTime = date + ' ' + classL.selectedSchedule.start;
                  classesWithNextDate++;
                  if (classesWithNextDate === this.lessons.length) {
                    finished = true;
                  }
                }
              });
              // console.log(this.curriculum);
            }
          });
        });
      });
    });
    return finished;
  }
  close() {
    this.dialog.closeAll();
  }
  openLessonByAllUsers() {

  }

  private resolveCurriculumNameFromPrograms(): string {
    const program = this.programs && this.programs.find(pr => {
      return (+pr.id === +this.programId) || (+pr.program_id === +this.programId);
    });
    const curriculums = program && program.curriculum ? program.curriculum : [];
    const lessonIds = (this.lessons || []).map(lesson => lesson.id);
    const matchingCurriculums = curriculums.filter(curriculum => {
      const lessons = curriculum && curriculum.lessons ? curriculum.lessons : [];
      return curriculum && curriculum.name && lessons.some(lesson => lessonIds.includes(lesson.id));
    });

    if (matchingCurriculums.length > 0) {
      return matchingCurriculums.map(curriculum => curriculum.name).join(', ');
    }

    return curriculums.length === 1 && curriculums[0].name ? curriculums[0].name : '';
  }
}
